import {
  DndContextProps,
  DndContext as DndKitContext,
  KeyboardCoordinateGetter,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { FC, PropsWithChildren } from 'react';

type TProps = {
  sortable?: boolean;
  hasKeyboardSensor?: boolean;
  keyboardCoordinateGetter?: KeyboardCoordinateGetter;
} & DndContextProps;

const DndContext: FC<PropsWithChildren<TProps>> = (props) => {
  const {
    children,
    sortable = false,
    hasKeyboardSensor = true,
    keyboardCoordinateGetter,
    ...rest
  } = props;

  const coordinateGetter =
    keyboardCoordinateGetter ??
    (sortable ? sortableKeyboardCoordinates : undefined);

  const sensors = useSensors(
    // useSensor(PointerSensor) is not used as it's a combination of MouseSensor and TouchSensor
    // and we want to use both separately to control different activation constraints
    useSensor(MouseSensor, {
      // Require the mouse to move by 10 pixels before activating
      // (if not set the onClick handle is intercepted and never triggered)
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(TouchSensor, {
      // Press delay of 250ms, with tolerance of 5px of movement
      // (if not set the onClick handle is intercepted and never triggered)
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    }),
    hasKeyboardSensor
      ? useSensor(
          KeyboardSensor,
          coordinateGetter ? { coordinateGetter } : undefined
        )
      : null
  );

  return (
    <DndKitContext sensors={sensors} {...rest}>
      {children}
    </DndKitContext>
  );
};

export default DndContext;
